import React, { useEffect } from 'react';
import { Input, Select, Button, Modal, Form } from 'antd';
import { bool, func, instanceOf } from 'prop-types';
import { isEmpty } from 'lodash';

import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.scss';

function Filters({ form, filters, isOpen, toggleModal, handleApplyFilterClick }) {
  function getLatLng(place) {
    const googlePlace = place.getPlace();
    const d = {
      city_place: {
        gpid: googlePlace.place_id,
        name: googlePlace.formatted_address,
      },
    };
    d.city = googlePlace.formatted_address;
    form.setFieldsValue(d);
  }

  useEffect(() => {
    setTimeout(() => {
      const placeInput = document.getElementById('city');

      if (placeInput) {
        const options = {
          types: ['geocode'],
        };

        const places = new window.google.maps.places.Autocomplete(placeInput, options);
        window.google.maps.event.addListener(places, 'place_changed', () => {
          getLatLng(places);
        });
        setTimeout(() => {
          placeInput.setAttribute('autocomplete', 'new-password');
        }, 2000);
      }
    }, 0);
  }, []);

  return (
    <Modal
      width={400}
      wrapClassName="filters-modal"
      visible={isOpen}
      closable={false}
      onCancel={toggleModal}
      title={
        <div className="arc-d-flex arc-flex-vertical-align">
          <Button type="link" onClick={toggleModal} size="small" className="modal-back-button">
            <FontAwesomeIcon icon={faArrowLeft} />
          </Button>
          <h6 className="arc-H200 ml16">
            <I18nCustomFormatter id="filters-modal-title" />
          </h6>
        </div>
      }
      footer={
        <Button size="large" className="apply-filters-btn" type="primary" block onClick={handleApplyFilterClick}>
          <I18nCustomFormatter id="apply-filters-label" />
        </Button>
      }>
      <div className="mentors-filters-wrapper">
        <Form layout="vertical" form={form}>
          <Form.Item name="city" color={false} label="Location" className="location-filter">
            <Input autoComplete="new-password" id="city" placeholder="Enter a city" allowClear />
          </Form.Item>
          <Form.Item name="city_place" style={{ display: 'none' }}>
            <Input type="hidden" id="city_place" />
          </Form.Item>
          <If condition={!isEmpty(filters)}>
            <Form.Item label="Services" name="services">
              <Select mode="multiple" placeholder="Please select">
                {filters?.service_filters.choices.map((service) => (
                  <Select.Option value={service} key={service}>
                    {service}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            {filters.form_field_filters.map((filter) => {
              const { id, label: filterLabel, choice_source_identifier: choiceSourceIdentifier, choices = [] } = filter;
              // Since crm fields will have list of label and value dict instead of choices
              const normalizedChoices = choiceSourceIdentifier ? choices.map(({ label }) => label) : choices;

              return (
                <Form.Item label={filterLabel} name={id} key={id}>
                  <Select mode="multiple" placeholder="Please select">
                    {normalizedChoices.map((choice) => (
                      <Select.Option value={choice} key={choice}>
                        {choice}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              );
            })}
          </If>
        </Form>
      </div>
    </Modal>
  );
}

Filters.propTypes = {
  filters: instanceOf(Object).isRequired,
  form: instanceOf(Object).isRequired,
  isOpen: bool.isRequired,
  toggleModal: func.isRequired,
  handleApplyFilterClick: func.isRequired,
};

export default Filters;
